// src/IconMaps.js
import React from "react";
import {
  Person as UserIcon,
  Folder as ProjectIcon,
  Description as SubmissionIcon,
  RateReview as ReviewIcon,
  FormatListNumbered as FormIcon,
  Event as EventIcon,
  History as LogIcon,
  AccountCircle as AccountIcon,
  HelpOutline as UnknownIcon,
} from "@mui/icons-material";

import {
  AddCircleOutline as InsertIcon,
  Edit as UpdateIcon,
  DeleteOutline as DeleteIcon,
} from "@mui/icons-material";

import { ActionType } from "./Enums";
import { ModelType, LogCategory } from "./models";


export const modelIcons = {
  [ModelType.USER]:       <UserIcon />,
  [ModelType.PROJECT]:    <ProjectIcon />,
  [ModelType.SUBMISSION]: <SubmissionIcon />,
  [ModelType.REVIEW]:     <ReviewIcon />,
  [ModelType.FORM]:       <FormIcon />,
  [ModelType.EVENT]:      <EventIcon />,
  [ModelType.LOG]:        <LogIcon />,
  [ModelType.ACCOUNT]:    <AccountIcon />,
  [ModelType.UNKNOWN]:    <UnknownIcon />,
};

export const actionIcons = {
  [ActionType.INSERT]: <InsertIcon />,
  [ActionType.UPDATE]: <UpdateIcon />,
  [ActionType.DELETE]: <DeleteIcon />,
};

export const actionLabels = {
  [ActionType.INSERT]:  "New",
  [ActionType.UPDATE]:  "Updated",
  [ActionType.DELETE]:  "Removed",
  // add more if you introduce extra actions
};

export const modelLabels = {
  [ModelType.USER]:       "User",
  [ModelType.PROJECT]:    "Project",
  [ModelType.SUBMISSION]: "Submission",
  [ModelType.REVIEW]:     "Review",
  [ModelType.FORM]:       "Form",
  [ModelType.EVENT]:      "Event",
  [ModelType.LOG]:        "Log",
  [ModelType.ACCOUNT]:    "Account",
  [ModelType.UNKNOWN]:    "Unknown",
};

export const categoryLabels = {
  [LogCategory.LOGIN]: "Login",
  [LogCategory.LOGOUT]: "Logout",
  [LogCategory.CREATED]: "Created",
  [LogCategory.UPDATED]: "Updated",
  [LogCategory.DELETED]: "Deleted",
  [LogCategory.CLONED]: "Cloned",
  [LogCategory.UNKNOWN]: "Unknown",
  [LogCategory.INITIALISE]: "Initialise",
  [LogCategory.COMMENT_ADDED]: "Comment Added",
  [LogCategory.FILE_UPLOADED]: "File Uploaded",
  [LogCategory.PERMISSIONS_UPDATED]: "Permissions Updated",
  [LogCategory.REVIEW_ASSIGNED]: "Review Assigned",
  [LogCategory.AI_REVIEW_GENERATED]: "AI Review Generated",
  [LogCategory.AI_SUGGESTION]: "AI Suggestion",
  [LogCategory.AI_ERROR]: "AI Error",
  [LogCategory.SEND]: "Send",
  [LogCategory.RESET]: "Reset",
  [LogCategory.APPROVAL_CHECK]: "Approval Check",
  [LogCategory.EMAIL_SENT]: "Email Sent",
};

export const logCategoryIcons = {
  [LogCategory.LOGIN]:             <UserIcon />,
  [LogCategory.LOGOUT]:            <UserIcon />,
  [LogCategory.CREATED]:           <UserIcon />,
  [LogCategory.UPDATED]:           <UserIcon />,
  [LogCategory.DELETED]:           <UserIcon />,
  [LogCategory.CLONED]:            <UserIcon />,
  [LogCategory.UNKNOWN]:           <UserIcon />,
  [LogCategory.INITIALISE]:        <UserIcon />,
  [LogCategory.COMMENT_ADDED]:     <UserIcon />,
  [LogCategory.FILE_UPLOADED]:     <UserIcon />,
  [LogCategory.PERMISSIONS_UPDATED]: <UserIcon />,
  [LogCategory.REVIEW_ASSIGNED]:   <UserIcon />,
  [LogCategory.AI_REVIEW_GENERATED]: <UserIcon />,
  [LogCategory.AI_SUGGESTION]:     <UserIcon />,
  [LogCategory.AI_ERROR]:          <UserIcon />,
  [LogCategory.SEND]:              <UserIcon />,
  [LogCategory.RESET]:             <UserIcon />,
  [LogCategory.APPROVAL_CHECK]:    <UserIcon />,
  [LogCategory.EMAIL_SENT]:        <UserIcon />,

  // Fallback if you ever get an unmapped category:
  default:                         <UserIcon />,
};
 